// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vv3tM","wrapperLanding":"styles_wrapperLanding__0z2Iu"};